import { useEffect, useState } from 'react';
import { PageHero } from '@/components/PageHero';
import { JournalCard } from '@/components/JournalCard';
import { CTASection } from '@/components/CTASection';
import { Reveal } from '@/components/Reveal';
import { SEO } from '@/components/SEO';
import { Skeleton } from '@/components/ui/skeleton';
import { getJournalPosts } from '@/lib/api';
import { SITE_IMAGES } from '@/lib/siteImages';
import { JOURNAL_PAGE } from '@/constants/testIds';
import { SkeletonList } from '@/components/SkeletonList';

export default function Journal() {
  const [posts, setPosts] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    getJournalPosts()
      .then(setPosts)
      .catch(() => setError(true));
  }, []);

  return (
    <div data-testid={JOURNAL_PAGE.root}>
      <SEO
        title="Journal"
        description="Photography tips, behind-the-scenes stories, and studio updates from LXRA Studios."
      />
      <PageHero
        kicker="Stories & Tips"
        title="JOURNAL"
        subtitle="Photography tips, behind-the-scenes stories, and studio updates."
        backgroundImage={SITE_IMAGES.aboutHero || SITE_IMAGES.galleriesHero}
      />

      <section className="bg-[#0A0A0A]">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-16 lg:py-24">
          {error && (
            <p className="text-sm text-[hsl(var(--lxra-muted))]">Unable to load journal posts right now. Please try again shortly.</p>
          )}

          {!posts && !error && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-testid={JOURNAL_PAGE.grid}>
              <SkeletonList count={3} className="aspect-[4/3] rounded-2xl bg-[#141416]" />
            </div>
          )}

          {posts && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-testid={JOURNAL_PAGE.grid}>
              {posts.map((post, i) => (
                <Reveal key={post.slug} delay={i * 0.05}>
                  <JournalCard post={post} />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>

      <CTASection testId="journal-cta-banner" buttonTestId="journal-cta-book-now-button" />
    </div>
  );
}
